import RevisorPage from '../../components/Revisor'
import React from 'react'
import Pagewrapper from '../../components/PageWrapper'

export default function () {
    return (
        <Pagewrapper>
            <RevisorPage />
        </Pagewrapper>
    )
}
